'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactResizeDetector = require('react-resize-detector');

var _reactResizeDetector2 = _interopRequireDefault(_reactResizeDetector);

var _throttle = require('lodash/throttle');

var _throttle2 = _interopRequireDefault(_throttle);

var _style = require('./style.css');

var _Log = require('../shared/Log');

var _Restart = require('../VideoProvider/Restart');

var _Restart2 = _interopRequireDefault(_Restart);

var _initializePlaybackTechnology = require('../shared/VideoStore/initializePlaybackTechnology');

var _initializePlaybackTechnology2 = _interopRequireDefault(_initializePlaybackTechnology);

var _FadeWrapper = require('../shared/FadeWrapper');

var _FadeWrapper2 = _interopRequireDefault(_FadeWrapper);

var _arePlayablesDifferent = require('./arePlayablesDifferent');

var _arePlayablesDifferent2 = _interopRequireDefault(_arePlayablesDifferent);

var _AdsPropType = require('../shared/AdsPropType');

var _AdsPropType2 = _interopRequireDefault(_AdsPropType);

var _PlayablesPropType = require('../shared/PlayablesPropType');

var _PlayablesPropType2 = _interopRequireDefault(_PlayablesPropType);

var _YouboraConfigPropType = require('../shared/YouboraConfigPropType');

var _YouboraConfigPropType2 = _interopRequireDefault(_YouboraConfigPropType);

var _ActivityTrackerOptionsPropType = require('../shared/ActivityTrackerOptionsPropType');

var _ActivityTrackerOptionsPropType2 = _interopRequireDefault(_ActivityTrackerOptionsPropType);

var _injectDefaults = require('./listeners/injectDefaults');

var _players = require('../store/actions/players');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-console */
/**
 * Copyright 2016, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Video
 */

var PLACEMENT_WARNING = 'Children of <Video/> should specify a placement prop of ON_VIDEO, OFF_VIDEO or OVER_VIDEO';
var PLACEMENT = {
  ON: 'ON_VIDEO',
  OFF: 'OFF_VIDEO',
  OVER: 'OVER_VIDEO',
  HIDDEN: 'HIDDEN'
};
var PLAYER_TIMEUPDATE_INTERVAL = 10;
var INSTANT = 50;
var TWO_SECONDS = 2000;

var Video = function (_React$Component) {
  _inherits(Video, _React$Component);

  function Video(props, context) {
    _classCallCheck(this, Video);

    var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, props, context));

    _this.onResize = function (width, height) {
      _this.context.store.dispatch((0, _players.setDimensions)(_this.state.playerId, width, height));
    };

    _this.fadeoutRows = _this.fadeoutRows.bind(_this);
    _this.mouseMove = _this.mouseMove.bind(_this);
    _this.mouseOut = _this.mouseOut.bind(_this);
    _this.setMouseHoveringOverRows = _this.setMouseHoveringOverRows.bind(_this);
    _this.pauseVideo = _this.pauseVideo.bind(_this);
    _this.debounceUpdate = (0, _throttle2.default)(function () {
      return _this.forceUpdate();
    }, 30);

    if (_this.props.logger) {
      (0, _Log.setLogSender)(_this.props.logger);
    }

    _this.state = {
      hoveringOverRows: false,
      playerId: context.playerId
    };
    return _this;
  }

  _createClass(Video, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.context.store.dispatch((0, _players.createPlayerInstance)(this.state.playerId));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.debounceUpdate);
      this.createRowFadeoutTimeout(TWO_SECONDS);

      this._video = (0, _initializePlaybackTechnology2.default)({
        ads: this.props.ads,
        autoplay: this.props.autoplay,
        domNode: this.holder,
        timeUpdateInterval: PLAYER_TIMEUPDATE_INTERVAL,
        player: this.props.player,
        playerId: this.state.playerId,
        poster: this.props.poster,
        logger: this.props.logger,
        muted: this.props.audioDisabled,
        youboraOptions: this.props.youboraConfig,
        activityTrackerOptions: this.props.activityTrackerOptions,
        theoLicenseUrl: this.props.theoLicenseUrl
      }, this.props.playables || []);

      if (Array.isArray(this.props.playables) && this.props.playables.length) {
        this.setPlayables(this.props.playables);
      }
      var dispatch = this.context.store.dispatch;

      dispatch((0, _players.setAutoPlay)(this.state.playerId, this.props.autoplay, false));
      dispatch((0, _players.setAutoAdvance)(this.state.playerId, this.props.autoAdvance));
      dispatch((0, _players.disableAudio)(this.state.playerId, this.props.audioDisabled));
      dispatch((0, _players.setMuteInternal)(this.state.playerId, this.props.audioDisabled));
      (0, _injectDefaults.injectDefaultListeners)(this.state.playerId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.autoplay !== this.props.autoplay) {
        this.handleNewAutoPlayProp(nextProps.autoplay);
      }
      if ((0, _arePlayablesDifferent2.default)(nextProps.playables, this.props.playables)) {
        this.setPlayables(nextProps.playables || []);
      }
      if (nextProps.autoAdvance !== this.props.autoAdvance) {
        this.context.store.dispatch((0, _players.setAutoAdvance)(this.state.playerId, nextProps.autoAdvance));
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.debounceUpdate);

      clearTimeout(this.hoverTimeout);
      this.unmounting = true;

      (0, _injectDefaults.removeDefaultListeners)(this.state.playerId);

      this.context.store.dispatch((0, _players.destroyPlayerInstance)(this.state.playerId));
    }
  }, {
    key: 'fadeoutRows',
    value: function fadeoutRows() {
      if (!this.state.hoveringOverRows && this.getPlayer().focused !== false) {
        this.context.store.dispatch((0, _players.setFocus)(this.state.playerId, false));
      }
    }
  }, {
    key: 'handleNewAutoPlayProp',
    value: function handleNewAutoPlayProp(autoplay) {
      var dispatch = this.context.store.dispatch;

      dispatch((0, _players.setAutoPlay)(this.state.playerId, autoplay));

      if (autoplay) {
        dispatch((0, _players.play)(this.state.playerId, true));
      } else {
        dispatch((0, _players.pause)(this.state.playerId, true));
      }
    }
  }, {
    key: 'getPlayer',
    value: function getPlayer() {
      return this.context.store.getState().players[this.state.playerId];
    }
  }, {
    key: 'setPlayables',
    value: function setPlayables(playables) {
      this.context.store.dispatch((0, _players.setPlayables)(this.state.playerId, playables));
    }
  }, {
    key: 'mouseMove',
    value: function mouseMove() {
      if (this.getPlayer().focused !== true) {
        this.context.store.dispatch((0, _players.setFocus)(this.state.playerId, true));
      }
      this.createRowFadeoutTimeout(TWO_SECONDS);
    }
  }, {
    key: 'mouseOut',
    value: function mouseOut() {
      if (process.env.NODE_ENV !== 'production') {
        if (location.search.search('keepControlsVisible') !== -1) {
          return;
        }
      }
      this.createRowFadeoutTimeout(INSTANT);
    }
  }, {
    key: 'createRowFadeoutTimeout',
    value: function createRowFadeoutTimeout(timeout) {
      clearTimeout(this.hoverTimeout);

      this.hoverTimeout = setTimeout(this.fadeoutRows, timeout);
    }
  }, {
    key: 'setMouseHoveringOverRows',
    value: function setMouseHoveringOverRows(hoveringOverRows) {
      this.setState({ hoveringOverRows: hoveringOverRows });
    }
  }, {
    key: 'pauseVideo',
    value: function pauseVideo() {
      var dispatch = this.context.store.dispatch;

      dispatch(this.getPlayer().paused ? (0, _players.play)(this.state.playerId, true) : (0, _players.pause)(this.state.playerId, true));
    }
  }, {
    key: 'filterAndOrganizeComponents',
    value: function filterAndOrganizeComponents(components, fullscreen) {
      var componentsOnVideo = [];
      var componentsOffVideo = [];
      var componentsOverVideo = [];

      _react2.default.Children.forEach(components, function (child) {
        if (child === null) return;

        if (process.env.NODE_ENV !== 'production') {
          if (!child.props || child.props && !child.props.placement) {
            console.warn(PLACEMENT_WARNING);
          }
        }

        var placement = child.props && child.props.placement ? child.props.placement : PLACEMENT.ON;

        if (fullscreen) {
          placement = child.props && child.props.fullscreenPlacement ? child.props.fullscreenPlacement : placement;
        }

        switch (placement) {
          case PLACEMENT.OVER:
            componentsOverVideo.push(child);
            break;
          case PLACEMENT.OFF:
            componentsOffVideo.push(child);
            break;
          case PLACEMENT.ON:
            componentsOnVideo.push(child);
            break;
          case PLACEMENT.HIDDEN:
          default:
            break;
        }
      });

      var useFadeWrapperOnVideo = this.props.useFadeWrapperOnVideo;

      return {
        componentsOnVideo: this.wrapOnVideoComponents(componentsOnVideo, useFadeWrapperOnVideo),
        componentsOffVideo: this.wrapOffVideoComponents(componentsOffVideo),
        componentsOverVideo: this.wrapOverVideoComponents(componentsOverVideo)
      };
    }
  }, {
    key: 'wrapOnVideoComponents',
    value: function wrapOnVideoComponents(components) {
      var _this2 = this;

      var includeFadeWrapper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      return components.length ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          {
            className: _style.videoNodeChildrenWrapper,
            onMouseMove: function onMouseMove() {
              return _this2.setMouseHoveringOverRows(true);
            },
            onMouseOut: function onMouseOut() {
              return _this2.setMouseHoveringOverRows(false);
            }
          },
          components
        ),
        includeFadeWrapper && _react2.default.createElement(
          _FadeWrapper2.default,
          null,
          _react2.default.createElement('div', { className: _style.videoNodeGradient })
        )
      ) : [];
    }
  }, {
    key: 'wrapOffVideoComponents',
    value: function wrapOffVideoComponents(components) {
      var _this3 = this;

      return components.length ? _react2.default.createElement(
        'div',
        {
          ref: function ref(node) {
            _this3.offVideoComponents = node;
          }
        },
        components
      ) : [];
    }
  }, {
    key: 'wrapOverVideoComponents',
    value: function wrapOverVideoComponents(components) {
      return components.length ? _react2.default.createElement(
        'div',
        { className: _style.videoOverlayComponents },
        components
      ) : [];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var videoElementWrapperClass = _style.videoElementWrapper;
      var restart = null;

      var _getPlayer = this.getPlayer(),
          fullscreen = _getPlayer.fullscreen,
          queueEnded = _getPlayer.queueEnded,
          focused = _getPlayer.focused,
          aspectRatio = _getPlayer.aspectRatio;

      if (!focused) {
        videoElementWrapperClass += ' ' + _style.videoNodeMouseHidden;
      }

      if (queueEnded) {
        restart = _react2.default.createElement(_Restart2.default, null);
      }

      var _filterAndOrganizeCom = this.filterAndOrganizeComponents(this.props.children, fullscreen || false),
          componentsOnVideo = _filterAndOrganizeCom.componentsOnVideo,
          componentsOffVideo = _filterAndOrganizeCom.componentsOffVideo,
          componentsOverVideo = _filterAndOrganizeCom.componentsOverVideo;

      var aspectRatioAsPercentage = {
        height: 0,
        paddingBottom: 100 / aspectRatio + '%'
      };
      if (aspectRatio === 0) {
        aspectRatioAsPercentage.paddingBottom = '100vh';
      }

      var wrapperInnerStyle = {};
      if (this.instanceWrapper && this.instanceWrapper.clientHeight && aspectRatio) {
        var offVideoComponentHeight = this.offVideoComponents && this.offVideoComponents.clientHeight || 0;
        var availableHeight = this.instanceWrapper.parentNode.clientHeight - offVideoComponentHeight;

        wrapperInnerStyle = {
          maxWidth: 'calc(' + availableHeight + 'px * ' + aspectRatio + ')'
        };
      }

      return _react2.default.createElement(
        'div',
        { className: _style.videoContainer },
        _react2.default.createElement(
          'div',
          {
            ref: function ref(node) {
              _this4.instanceWrapper = node;
            },
            className: _style.videoContainerDiv
          },
          _react2.default.createElement(
            'div',
            { className: _style.videoInnerContainer },
            _react2.default.createElement(
              'div',
              {
                className: videoElementWrapperClass,
                onMouseMove: this.mouseMove,
                onMouseOut: this.mouseOut
              },
              componentsOnVideo,
              _react2.default.createElement(
                'div',
                {
                  className: _style.videoElementWrapperInner,
                  style: wrapperInnerStyle
                },
                _react2.default.createElement(_reactResizeDetector2.default, {
                  handleWidth: true,
                  handleHeight: true,
                  onResize: this.onResize,
                  refreshMode: 'debounce',
                  refreshRate: 50
                }),
                componentsOverVideo,
                _react2.default.createElement('div', {
                  ref: function ref(node) {
                    _this4.holder = node;
                  },
                  style: aspectRatioAsPercentage
                })
              ),
              restart,
              !this.getPlayer().adBegan && _react2.default.createElement('div', { className: _style.videoOverlay, onClick: this.pauseVideo })
            )
          ),
          componentsOffVideo
        )
      );
    }
  }]);

  return Video;
}(_react2.default.Component);

Video.propTypes = {
  ads: _AdsPropType2.default,
  autoAdvance: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  autoplay: _propTypes2.default.bool,
  playables: _PlayablesPropType2.default,
  player: _propTypes2.default.string,
  poster: _propTypes2.default.string,
  logger: _propTypes2.default.func,
  useFadeWrapperOnVideo: _propTypes2.default.bool,
  audioDisabled: _propTypes2.default.bool,
  youboraConfig: _YouboraConfigPropType2.default,
  activityTrackerOptions: _ActivityTrackerOptionsPropType2.default,
  theoLicenseUrl: _propTypes2.default.string
};
Video.contextTypes = {
  playerId: _propTypes2.default.string,
  state: _propTypes2.default.object.isRequired,
  store: _propTypes2.default.object.isRequired
};
Video.defaultProps = {
  audioDisabled: false,
  autoAdvance: true
};
exports.default = Video;
module.exports = exports['default'];